<cx-carousel class="gen-product-carousel" *ngIf="items$ | async as items" role="region" [attr.aria-label]="
    'productCarousel.carouselLabel' | cxTranslate : { title: title$ | async }
  " [items]="items" [title]="title$ | async" [template]="carouselItem" itemWidth="300px">
</cx-carousel>

<ng-template #carouselItem let-item="item">
  <gen-product-carousel-item [item]="item" [gaListName]="gaListName"></gen-product-carousel-item>
</ng-template>